
define('text!sharingTemplate/sharing.mustache',[],function () { return '<ul class="bam-social">\n <li class="email slideLeft"><a href="#"></a></li>\n <li class="facebook slideLeft2"><a href="#"></a></li>\n <li class="twitter slideLeft3"><a href="#"></a></li>\n <li class="google slideLeft4" id="google-top"><a href="#"></a></li>\n</ul>';});

